<!-- @format -->

<ng-container *transloco="let t">
  <fudis-section [class]="'fudis-mt-md'" [level]="2" [titleVariant]="'lg'" [title]="'1. ' + t('ADD_TO_PLAN_WIZARD.CHOOSE_DESTINATION')">
    <fudis-section-content>
      @if (isFormInvalidOnNextClick()) {
        <fudis-notification [variant]="'danger'" #planWizardErrorSummary>
          <fudis-body-text>{{ t("ADD_TO_PLAN_WIZARD.VALIDATION.ERROR_SUMMARY") }}</fudis-body-text>
          <ul>
            @for (error of collectValidationErrors(); track error.elementId) {
              <li class="fudis-mt-xxs">
                <a fudisLink [title]="error.message" [size]="'md'" [href]="'#'" (click)="setFocusToNotification()"></a>
              </li>
            }
          </ul>
        </fudis-notification>
      }
      <fudis-heading [class]="'fudis-mt-sm'" [level]="3" [variant]="'md'">
        {{ t("ADD_TO_PLAN_WIZARD.SELECTED_COURSE_UNIT") }}</fudis-heading
      >
      @if ((courseUnit || customCourseUnitAttainment) && initialPlanId && planStructureData(); as data) {
        <ng-container
          [sisPlanStructureContext]="{ planStateObject: data.planStateAndData.planStateObject, planData: data.planStateAndData.planData }">
          @if (courseUnit) {
            <sis-plan-structure-course-unit [courseUnit]="courseUnit" [headingLevel]="4" [nameClickable]="false" [showAttainment]="false">
            </sis-plan-structure-course-unit>
          } @else {
            <sis-plan-structure-custom-course-unit-attainment
              [customCourseUnitAttainment]="customCourseUnitAttainment"
              [nameClickable]="false"
              [headingLevel]="4">
            </sis-plan-structure-custom-course-unit-attainment>
          }
        </ng-container>
        <fudis-section [class]="'fudis-mt-md'" [level]="3" [titleVariant]="'md'" [title]="t('ADD_TO_PLAN_WIZARD.DESTINATION')">
          <fudis-section-content>
            <app-plan-header
              [allStudentPlans]="data.allStudentPlans"
              [currentPlan]="data.plan"
              [showHorizontalRule]="false"
              (selectPlan)="this.handlePlanChange($event)" />
            <fudis-heading id="moduleSelector" [class]="'fudis-mt-md'" [level]="4" [variant]="'xs'">
              {{ t("ADD_TO_PLAN_WIZARD.VALID_STUDY_MODULES") }}
            </fudis-heading>
            @if (isFormInvalidOnNextClick()) {
              <fudis-notification [variant]="'danger'" #planWizardErrorNotification>
                <fudis-body-text>{{ t("ADD_TO_PLAN_WIZARD.VALIDATION.NO_MODULE_SELECTED") }}</fudis-body-text>
              </fudis-notification>
            }
            <fudis-grid [columns]="1">
              @for (moduleId of getModuleIds(data); track moduleId) {
                <fudis-grid-item>
                  <div class="add-to-plan-wizard__module-summary-box">
                    <fudis-grid [columns]="'min-content auto'" [columnGap]="'none'">
                      <sis-radio-button
                        [ngClass]="{
                          'add-to-plan-wizard__module-summary-box__invalid_selection': isFormInvalidOnNextClick(),
                        }"
                        [value]="moduleId"
                        [control]="moduleGroupControl" />
                      <app-plan-structure-module-summary
                        [headingLevel]="5"
                        [module]="getModule(moduleId, data.planStateAndData.planData)"
                        [planStructureData]="data" />
                    </fudis-grid>
                  </div>
                </fudis-grid-item>
              }
            </fudis-grid>
          </fudis-section-content>
        </fudis-section>
      } @else {
        @if (courseUnit || customCourseUnitAttainment; as cu) {
          <sis-study-box [id]="cu.id" [name]="cu.name" [code]="cu.code" [credits]="getCreditRange(cu.credits)" />
          <fudis-heading [class]="'fudis-mt-sm'" [level]="3" [variant]="'md'">
            {{ t("ADD_TO_PLAN_WIZARD.DESTINATION") }}
          </fudis-heading>
          @if (!loadingState()) {
            <fudis-notification [variant]="'danger'" #planWizardErrorNotification>
              <fudis-body-text>{{ t("ADD_TO_PLAN_WIZARD.VALIDATION.NO_PLANS_FOUND") }}</fudis-body-text>
            </fudis-notification>
          }
        } @else {
          <fudis-notification [variant]="'danger'" #planWizardErrorNotification>
            <fudis-body-text>{{ t("ADD_TO_PLAN_WIZARD.VALIDATION.NO_COURSE_UNIT_SELECTED") }}</fudis-body-text>
          </fudis-notification>
        }
      }
    </fudis-section-content>
  </fudis-section>
  <sis-wizard-step-buttons
    [backButtonDisplay]="false"
    [forwardButtonTitle]="t('SIS_COMPONENTS.BUTTON.CONTINUE')"
    (forward)="nextClicked()" />
</ng-container>
